<template>
	<div>
		<!-- begin profile -->
		<div class="profile">
			<div class="profile-header">
				<!-- BEGIN profile-header-cover -->
				<div class="profile-header-cover"></div>
				<!-- END profile-header-cover -->
				<!-- BEGIN profile-header-content -->
				<div class="profile-header-content">
					<!-- BEGIN profile-header-img -->
					<div class="profile-header-img">
						<img src="/app/assets/logo.png" alt="">
					</div>
					<!-- END profile-header-img -->
					<!-- BEGIN profile-header-info -->
					<div class="profile-header-info">
						<h4 class="m-t-10 m-b-5">{{ this.$store.state.usuario.nombres+' '+this.$store.state.usuario.appa+' '+this.$store.state.usuario.apma	}}</h4>
						<p class="m-b-10">{{ this.$store.state.usuario.tipo=="1" ? 'Administrador':'Vendedor'  }}</p>
					</div>
					<!-- END profile-header-info -->
				</div>
				<!-- END profile-header-content -->
				<!-- BEGIN profile-header-tab -->
				<ul class="profile-header-tab nav nav-tabs">
					<li class="nav-item"><a href="javascript:;" v-on:click="show('about')" v-bind:class="{ 'active': tab.about }" class="nav-link" data-toggle="tab">DATOS</a></li>
				</ul>
				<!-- END profile-header-tab -->
			</div>
		</div>
		<!-- end profile -->
		<!-- begin profile-content -->
		<div class="profile-content ">
			<!-- begin tab-content -->
			<div class="tab-content p-0 ">
			
				<!-- begin #profile-about tab -->
				<div class="tab-pane fade" v-bind:class="{ 'show active': tab.about }">
					<!-- begin table -->
					<div class="table-responsive form-inline ">
						<table class="table table-profile">
							<thead>
								<tr>
									<th></th>
									<th>
										<h4>Cambiar clave de acceso</h4>
									</th>
								</tr>
							</thead>
							<tbody>
								
								<tr>
									<td class="field valign-middle">Ap. Paterno</td>
									<td>
										<input type="text" :value="datos.appa" readonly class="form-control form-control-sm">
									</td>
								</tr>
								<tr>
									<td class="field valign-middle">Ap. Materno</td>
									<td>
										<input type="text" :value="datos.apma"  readonly class="form-control form-control-sm">
									</td>
								</tr>
								<tr>
									<td class="field valign-middle">Nombres</td>
									<td>
										<input type="text" :value="datos.nombres"  readonly class="form-control form-control-sm">
									</td>
								</tr>
								<tr>
									<td class="field valign-middle">Clave</td>
									<td>
											<input type="password" v-model="datos.clave" class="form-control form-control-sm">
									</td>
								</tr>
								<tr>
									<td class="field valign-middle">DNI</td>
									<td>
									<input type="text" :value="datos.dni" readonly class="form-control form-control-sm">
									</td>
								</tr>
								
								<tr class="highlight">
									<td class="field valign-middle">&nbsp;</td>
									<td class="p-t-10 p-b-10">
										<button type="button" @click="actualizarClave()" class="btn btn-primary width-150">Actualizar</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- end table -->
				</div>
				<!-- end #profile-about tab -->
			
			
			</div>
			<!-- end tab-content -->
		</div>
		<!-- end profile-content -->
	</div>
</template>

<script>
import PageOptions from '../config/PageOptions.vue'
import axios from 'axios'
export default {
	data() {
		return {
			tab: {
				about: true,
			},
			datos:{
				appa:'',
				apma:'',
				nombres:'',
				dni:'',
				celular:'',
				domicilio:'',
				email:'',
				clave:'',
				tipo:'',
				estado:''
			}
		}
	},
	methods: {


		show: function(x) {
			this.tab.about = false;
			
			switch (x) {
				case 'about':
					this.tab.about = true;
					break;
				case 'video':
					this.tab.video = true;
					break;
				case 'photo':
					this.tab.photo = true;
					break;
				case 'friend':
					this.tab.friend = true;
					break;
				default:
					this.tab.post = true;
					break;
			}
		},
		actualizarClave(){
				// this.proceso=true;
			 axios.put(this.URL_BASE()+"personal/update/",this.datos).then(respuesta => {
            //   console.log(respuesta.data.msg)
				if(respuesta.data.msg=='exito'){
					this.exito("Clave actualizada correctamente");
				}
				// this.proceso=false;
            }).catch((error)=> {
              console.log("er store"+error);
            });
		}
	},
	created() {
		PageOptions.pageContentFullWidth = true;


		this.datos={...this.$store.state.usuario}
	},
	beforeRouteLeave (to, from, next) {
		PageOptions.pageContentFullWidth = false;
		next();
	}
}
</script>